import React from 'react';
import { Col, Row, Text } from '@metaicg/sensei-ui';
import { HeaderStyled } from './styles';
import { LayoutWrapper } from '@/shared/components/layout';
import Logo from '@/shared/components/logo/logo';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '@/routes';
import LanguageSelector from '@/shared/components/language-selector';

const Header = ({ showLogo = true }: { showLogo?: boolean }) => (
  <HeaderStyled role="header">
    <LayoutWrapper>
      <Row justify={showLogo ? 'space-between' : 'end'} align="middle" gutter={[30, 30]}>
        {showLogo && (
          <Col span={100}>
            <Text size="title" weight="medium">
              <Link to={ROUTE_PATHS.rootLogged}>
                <Logo />
              </Link>
            </Text>
          </Col>
        )}
        <Col>
          <LanguageSelector />
        </Col>
      </Row>
    </LayoutWrapper>
  </HeaderStyled>
);

export default Header;
